/**
 * Formats a 10-digit phone number into (XXX) XXX-XXXX, returns '-' when empty, and passes through unmatched values.
 */
export const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) {
    return '-';
  }

  // Use a regular expression to capture the different parts of the phone number
  const regex = /^(\d{3})(\d{3})(\d{4})$/;

  // Replace the matched pattern with the desired format
  const formattedNumber = phoneNumber.replace(regex, '($1) $2-$3');

  return formattedNumber;
};
